import React from 'react'

export const SwapSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask
      id="mask0_1342_43651"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="25"
    >
      <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1342_43651)">
      <path
        d="M7 21.5L2 16.5L7 11.5L8.425 12.9L5.825 15.5H21V17.5H5.825L8.425 20.1L7 21.5ZM17 13.5L15.575 12.1L18.175 9.5H3V7.5H18.175L15.575 4.9L17 3.5L22 8.5L17 13.5Z"
        fill="#615CFF"
      />
    </g>
  </svg>
)
